import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PropTypes } from 'prop-types';
import moment from 'moment';
// import htmlToText from 'html-to-text';
import { NavLink } from 'react-router-dom';
import { Card, Badge } from 'react-bootstrap';
import Pagination from '../../common/Pagination';
import LoadingOverlay from '../../common/LoadingOverlay';
import { useTranslation } from 'react-i18next';
import NotificationListItem from './NotificationListItem';
import { fetchNotifications } from '../../../actions';

import usePagination from '../../../hooks/usePagination';

NotificationsList.propTypes = {
	partnerID: PropTypes.string,
	userID: PropTypes.string
}

function NotificationsList(props) {
	const { partnerID, userID, dashboard, limit, eventID, archive } = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const notificationsState = useSelector(({ notifications }) => notifications);
	const { loading, /* error */ } = notificationsState;
	let { notifications } = notificationsState;
	notifications = eventID ? notifications.filter(n => n.eventID === eventID) : notifications;

	const _fetchNotifications = useCallback(() => {
		if (partnerID && userID) {
			dispatch(fetchNotifications(partnerID, userID));
		}
	}, [dispatch, partnerID, userID]);

	useEffect(() => {
		_fetchNotifications();
	}, [_fetchNotifications])

	const {
		setPage,
		pageCount,
		currentPage,
		currentData,
	} = usePagination(notifications, limit);

	const currentNotifications = currentData().sort((a, b) => moment(b.timeToShow).unix() - moment(a.timeToShow).unix());
	const notificationsNotRead = notifications.filter(n => !n.markedAsRead).length;

	const paginate = ({ selected }) => setPage(selected + 1);

	return (
		<>
			{dashboard ?
				<h3>{t('notifications.header')}</h3>
			: null}
			<Card>
				<Card.Header>
					{t('notifications.notifications')} &nbsp;
					{notificationsNotRead > 0 ?
						<>
							<Badge pill variant="success">
								{notificationsNotRead}
							</Badge>
						</>
					: null}
					{!archive ? <NavLink to={dashboard ? '/notifications' : `${eventID}/notifications`} className="btn btn-link btn-sm float-right">{t('notifications.archive')}</NavLink> : null}
				</Card.Header>
				<Card.Body style={{ position: 'relative' }}>
					{currentNotifications.map((notification, i) => (
						<div key={notification.notificationID}>
							<NotificationListItem
								notification={notification}
								fetchNotifications={_fetchNotifications}
								bottomBorder={i !== currentNotifications.length - 1}
								archive={archive}
							/>
						</div>
					))}
				
					{notifications.length < 1 && !loading ?
						<p>{t('notifications.no_notifications')}</p>
					: null}
				
					{loading ?
						<LoadingOverlay />
					: null}
				</Card.Body>

				{notifications.length ?
					<Card.Footer style={{ borderTop: '1px solid #F0F0F0' }}>
						<div className="pull-right">
							<Pagination
								forcePage={currentPage}
								pageCount={pageCount}
								marginPagesDisplayed={2}
								pageRangeDisplayed={5}
								onPageChange={paginate}
							/>
						</div>
					</Card.Footer>
				: null}
			</Card>
		</>
	);
}

export default NotificationsList;